var navigationPublic = {
    welcome:"Bienvenido",
    rewards:"Recompensas",
    register:"Registro",
    registerAgency:"Registro para agencias",
    registerAgent:"Registro para agente/agencia",
    login:"Acceso",
    lang:"English",
    contact:"Contacto"

}
module.exports = navigationPublic
